import { EventGroup } from '~/Models/DTO/EventGroup.model';
import { INeoAction } from './../Actions.interface';
import { REQUEST_ACTIONS, STATUS } from '~/Constants/Actions.constants';
import { isActionValid } from '~/Helpers/Reducer.helper';
import { IEvent } from '~/Models/DTO/Event.model';

const useValidActions = isActionValid([
  REQUEST_ACTIONS.GET_EVENTGROUP,
  REQUEST_ACTIONS.POST_EVENTGROUP,
  REQUEST_ACTIONS.DELETE_EVENTGROUP,
  REQUEST_ACTIONS.GET_NEXT_EVENTS,
  REQUEST_ACTIONS.DELETE_NEXT_EVENT_BY_GROUP_ID,
  REQUEST_ACTIONS.PATCH_EVENTGROUP,
  REQUEST_ACTIONS.GET_EVENTGROUP_LIST,
  REQUEST_ACTIONS.GET_SYNCED_EVENT_GROUP_LIST,
]);

interface ISyncedEvent {
  providerId: string;
  eventGroupId: string;
}

interface ILocalState {
  list: EventGroup[];
  item: EventGroup | null;
  syncedList: ISyncedEvent[];
  nextEventsMap: { [key: string]: IEvent };
}

const initialState: ILocalState = {
  list: [],
  item: null,
  syncedList: [],
  nextEventsMap: {},
};

export default (state = initialState, action: INeoAction): ILocalState => {
  const { name, status, payload } = action;

  const actionValid = useValidActions(name);

  if (actionValid && status === STATUS.SUCCESS) {
    switch (name) {
      case REQUEST_ACTIONS.GET_EVENTGROUP:
      case REQUEST_ACTIONS.POST_EVENTGROUP:
      case REQUEST_ACTIONS.PATCH_EVENTGROUP:
        return {
          ...state,
          item: payload,
        };
      case REQUEST_ACTIONS.DELETE_EVENTGROUP:
        return {
          ...state,
          item: null,
          list: state.list.filter((item) => item.id !== payload.id),
        };
      case REQUEST_ACTIONS.DELETE_NEXT_EVENT_BY_GROUP_ID:
        return {
          ...state,
          nextEventsMap: Object.assign(
            {},
            ...state.list
              .filter((item) => item.id !== payload.id)
              .map((eventGroup) => ({
                [eventGroup.id]: state.nextEventsMap?.[eventGroup.id],
              })),
          ),
        };
      case REQUEST_ACTIONS.GET_EVENTGROUP_LIST:
        return {
          ...state,
          list: payload,
        };
      case REQUEST_ACTIONS.GET_SYNCED_EVENT_GROUP_LIST:
        return {
          ...state,
          syncedList: payload,
        };
      case REQUEST_ACTIONS.GET_NEXT_EVENTS: {
        return {
          ...state,
          nextEventsMap: Object.assign(
            {},
            ...payload
              ?.filter(({ content }: { content: IEvent[] }) => content?.[0])
              .map(({ content }: { content: IEvent[] }) => {
                const event = content?.[0];
                return { [event?.eventGroupId]: event };
              }),
          ),
        };
      }
      default:
        return state;
    }
  }

  return state;
};
